import styled, { css } from 'styled-components';

interface IContainer {
  isLinked: boolean;
  active: boolean;
}

export const Container = styled.div<IContainer>`
  background: var(--white-darker);
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--gray-e);

  ${props =>
    props.isLinked &&
    css`
      cursor: pointer;
      transition: background 0.2s ease;

      :hover {
        background: rgba(0, 0, 0, 0.05);
      }
    `}

  ${props =>
    props.active &&
    css`
      border: 1px solid var(--info);
    `}



  > div {
    display: flex;
    min-width: 0;

    div.info {
      display: flex;
      flex-direction: column;
      margin-left: 10px;
      min-width: 0;

      p {
        font-size: 12px;
        color: var(--gray-9);
        font-weight: 500;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      strong {
        font-size: 16px;
        font-weight: bold;
        color: var(--black-2);

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
`;

export const Image = styled.img`
  background: var(--gray-d);
  border-radius: 8px;
  height: 40px;
  width: 40px;
  object-fit: cover;
`;

export const Badge = styled.span`
  background: var(--gray-9);
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  color: var(--white);
  padding: 5px 10px;
  white-space: nowrap;
  margin-left: 10px;
`;

interface ISelectDot {
  active: boolean;
}

export const SelectDot = styled.div<ISelectDot>`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 40px;
  width: 24px;
  margin-right: 8px;

  > div {
    height: 24px;
    width: 24px;
    border: 1px solid var(--gray-e);
    background: var(--white);
    border-radius: 50%;

    position: relative;

    transition: 0.2s ease;

    ${props =>
      props.active &&
      css`
        ::after {
          content: '';
          background: var(--info);
          height: 14px;
          width: 14px;
          border-radius: 50%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      `}
  }
`;
